(() => {
  const reviews = [
  {
    "id": "chopsmart-ae-2026-04-09",
    "rating": 5,
    "author": "Anonym",
    "originalAuthor": "AliExpress-Einkäufer",
    "date": "2026-04-09",
    "text": "Der Artikel kam schnell an, alle aufgeführten Teile waren dabei. Ich habe es noch nicht verwendet, werde aber zurückkommen und noch einmal überprüfen, wie gut es funktioniert.",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "chopsmart-ae-2026-09-05",
    "rating": 4,
    "author": "Anonym",
    "originalAuthor": "AliExpress-Einkäufer",
    "date": "2026-09-05",
    "text": "Ich habe die Bestellung pünktlich erhalten. Alles in Ordnung. Komplettes Set. Ich habe versucht, die Zwiebel mit der Reibe zu schneiden, hatte aber Angst, etwas zu zerbrechen. Die Zwiebel ist dafür zu hart. Ansonsten scheint alles in Ordnung zu sein.",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "chopsmart-ae-2026-02-28",
    "rating": 5,
    "author": "Anonym",
    "originalAuthor": "AliExpress-Einkäufer",
    "date": "2026-02-28",
    "text": "Vielen Dank! Ich bin sehr zufrieden mit dem Schaber! Ich empfehle den Verkäufer!",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "chopsmart-ae-2026-03-02",
    "rating": 4,
    "author": "C***r",
    "date": "2026-03-02",
    "text": "Es kam in gutem Zustand an und funktioniert einwandfrei.",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "chopsmart-ae-2025-12-24",
    "rating": 5,
    "author": "A***e",
    "date": "2025-12-24",
    "text": "Vielen Dank an den Verkäufer für die schnelle Lieferung, das Produkt ist gut!",
    "external": true,
    "source": "aliexpress"
  }
];

  const dryStepReviews = [
  {
    "id": "drystep-ae-1",
    "rating": 5,
    "author": "AliExpress-Einkäufer",
    "date": "2025-12-09",
    "text": "Sehr zufrieden mit dem Trockner. Ich habe versucht, ein paar Sneaker zu trocknen, die gerade aus der Waschmaschine kamen, und nach 50 Minuten waren sie halb trocken.",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "drystep-ae-2",
    "rating": 5,
    "author": "AliExpress-Einkäufer",
    "date": "2026-06-17",
    "text": "Ein sehr guter Schuhtrockner! Die warme Luft, die durch die Rohre strömt, trocknet Schuhe sehr schnell. Er eignet sich auch hervorragend für Kinderschuhe!",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "drystep-ae-3",
    "rating": 5,
    "author": "Ч***ч",
    "date": "2026-06-16",
    "text": "Ein guter Trockner für den Preis, gut verarbeitet, habe ihn schon mehrmals benutzt, schaltet sich bequem per Timer aus.",
    "external": true,
    "source": "aliexpress",
    "images": [
      "https://cdn.shopify.com/s/files/1/1029/1829/1803/files/drystep-review-20260616-1.png?v=1790211387",
      "https://cdn.shopify.com/s/files/1/1029/1829/1803/files/drystep-review-20260616-2.png?v=1790211399"
    ]
  },
  {
    "id": "drystep-ae-4",
    "rating": 4,
    "author": "AliExpress-Einkäufer",
    "date": "2025-12-06",
    "text": "Artikel kommt wie beschrieben an und funktioniert.",
    "external": true,
    "source": "aliexpress"
  },
  {
    "id": "drystep-ae-5",
    "rating": 4,
    "author": "AliExpress-Einkäufer",
    "date": null,
    "text": "Es heizt sehr gut und trocknet schnell. Der Abschalt-Timer funktioniert. Aber die Hitze ist meiner Meinung nach sehr stark;",
    "external": true,
    "source": "aliexpress"
  }
];


  const displayAuthor = (value) => {
    const name = (value || '').trim();
    return !name || /^(anonym(?:ous)?|aliexpress[\s-]*(?:einkäufer|käufer|buyer|shopper|user))$/i.test(name) ? 'Anonym' : name;
  };

  const normalizeReviewDisplay = (section) => {
    section.querySelectorAll('.cv-review').forEach((card) => {
      const author = card.querySelector('figcaption span:not(.cv-review__avatar)');
      if (author) {
        const name = displayAuthor(author.textContent);
        author.textContent = name;
        const avatar = card.querySelector('.cv-review__avatar');
        if (avatar) avatar.textContent = name.charAt(0).toUpperCase();
      }
    });
    const sourceLabels = [...section.querySelectorAll('.cv-review__source')];
    const notes = [...section.querySelectorAll('[data-cv-review-origin-note]')];
    if (!sourceLabels.length && !notes.length) return;
    sourceLabels.forEach((label) => { label.hidden = true; });
    let note = notes.shift();
    notes.forEach((duplicate) => duplicate.remove());
    if (!note) {
      note = document.createElement('p');
      note.className = 'cv-reviews__origin-note';
      note.dataset.cvReviewOriginNote = 'true';
      section.querySelector('.cv-reviews__grid')?.insertAdjacentElement('afterend', note);
    }
    note.textContent = 'Einzelne Bewertungen können aus externen Produktbewertungen stammen.';
  };

  const previewMode = Boolean(window.Shopify?.designMode)
    || new URLSearchParams(window.location.search).get('kabo_review_test') === '1';


  const addSummaryStyles = () => {
    if (document.querySelector('[data-cv-review-summary-styles]')) return;
    const style = document.createElement('style');
    style.dataset.cvReviewSummaryStyles = 'true';
    style.textContent = `
      .cv .cv-review-summary{display:inline-flex;align-items:center;gap:9px;margin:0 0 16px;color:var(--cv-muted);font-size:11px;line-height:1.4;text-decoration:none}
      .cv .cv-review-summary:hover .cv-review-summary__count{text-decoration:underline;text-underline-offset:4px}
      .cv .cv-review-summary__stars{display:inline-flex;gap:2px;color:#6d8234;font-size:14px;letter-spacing:.02em;line-height:1}
      .cv .cv-review-summary__score{font-weight:700;color:var(--cv-ink)}
      .cv .cv-review-summary__count{color:var(--cv-muted)}
      .cv .cv-reviews__origin-note{margin:14px 0 0;color:var(--cv-muted);font-size:11px;line-height:1.55}
      .cv .cv-review__photos{display:flex;flex-wrap:wrap;gap:10px;margin-top:12px;grid-column:1/-1}
      .cv .cv-review__photos button{display:block;border:0;padding:0;cursor:zoom-in;border-radius:6px;overflow:hidden}
      .cv .cv-review__photos img{display:block;width:90px;height:120px;object-fit:contain;background:#edf2ec}
      .cv .cv-review__photos button:focus-visible{outline:2px solid #183c3d;outline-offset:3px}
      .kabo-review-dialog{padding:16px;border:0;border-radius:12px;background:#fbfcf9;color:#183c3d;width:min(900px,94vw);max-width:94vw;max-height:94dvh;box-sizing:border-box}
      .kabo-review-dialog::backdrop{background:rgba(0,0,0,.78)}
      .kabo-review-dialog__bar{display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:10px}
      .kabo-review-dialog button{width:44px;height:44px;flex-shrink:0;border:1px solid #d6dfd8;border-radius:50%;background:#edf2ec;color:#183c3d;font-size:24px;cursor:pointer}
      .kabo-review-dialog button:focus-visible{outline:2px solid #183c3d;outline-offset:2px}
      .kabo-review-dialog__stage{display:flex;align-items:center;justify-content:center;gap:8px;touch-action:pan-y}
      .kabo-review-dialog__stage img{display:block;min-width:0;max-width:calc(100% - 104px);max-height:72dvh;object-fit:contain}
      .kabo-review-dialog button[hidden]{display:none}
      @media(max-width:849px){.cv .cv-review-summary{min-height:30px;margin-bottom:12px}.cv .cv-reviews__origin-note{font-size:10px}}
    `;
    document.head.appendChild(style);
  };

  const renderOriginNote = (section, grid, visibleReviews, productName) => {
    if (!visibleReviews.some((review) => review.external) || section.querySelector('[data-cv-review-origin-note]')) return;
    const note = document.createElement('p');
    note.className = 'cv-reviews__origin-note';
    note.dataset.cvReviewOriginNote = 'true';
    note.textContent = 'Einzelne Bewertungen können aus externen Produktbewertungen stammen.';
    grid.insertAdjacentElement('afterend', note);
  };


  const createReviewGallery = (page) => {
    const dialog = document.createElement('dialog');
    dialog.className = 'kabo-review-dialog';
    dialog.setAttribute('aria-label', 'Kundenbilder');
    const bar = document.createElement('div');
    bar.className = 'kabo-review-dialog__bar';
    const counter = document.createElement('span');
    counter.setAttribute('aria-live', 'polite');
    const button = (label, text) => {
      const element = document.createElement('button');
      element.type = 'button';
      element.setAttribute('aria-label', label);
      element.textContent = text;
      return element;
    };
    const close = button('Bilder schließen', '×');
    const previous = button('Vorheriges Kundenbild', '←');
    const next = button('Nächstes Kundenbild', '→');
    const stage = document.createElement('div');
    stage.className = 'kabo-review-dialog__stage';
    const image = document.createElement('img');
    image.draggable = false;
    bar.append(counter, close);
    stage.append(previous, image, next);
    dialog.append(bar, stage);
    page.append(dialog);
    let images = [];
    let active = 0;
    let author = '';
    let opener;
    const show = (index) => {
      active = (index + images.length) % images.length;
      image.src = images[active];
      image.alt = `Kundenbild ${active + 1} von ${author}`;
      counter.textContent = `Bild ${active + 1} von ${images.length}`;
      previous.hidden = next.hidden = images.length < 2;
    };
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    previous.addEventListener('click', () => show(active - 1));
    next.addEventListener('click', () => show(active + 1));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    let start;
    stage.addEventListener('touchstart', (event) => {
      start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    }, { passive: true });
    stage.addEventListener('touchend', (event) => {
      if (!start || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - start.x;
      const dy = event.changedTouches[0].clientY - start.y;
      start = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) show(active + (dx < 0 ? 1 : -1));
    }, { passive: true });
    stage.addEventListener('touchcancel', () => { start = null; }, { passive: true });
    return (review, index, trigger) => {
      images = review.images;
      author = displayAuthor(review.author);
      opener = trigger;
      show(index);
      dialog.showModal();
      close.focus();
    };
  };

  const render = (page) => {
    const productReviews = { ChopSmart: reviews, DryStep: dryStepReviews }[page.dataset.productName] || [];
    const visibleReviews = productReviews.filter((review) => !review.test || previewMode);
    const section = page.querySelector('#cv-reviews');
    if (!section) return;
    normalizeReviewDisplay(section);
    if (!visibleReviews.length) return;

    addSummaryStyles();


    let grid = section.querySelector('.cv-reviews__grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'cv-reviews__grid';
      section.querySelector('.cv-reviews__heading')?.insertAdjacentElement('afterend', grid);
    }

    grid.classList.add('cv-reviews__grid--rows');

    section.querySelector('.cv-reviews__empty')?.setAttribute('hidden', '');

    let openGallery;
    visibleReviews.forEach((review) => {
      if (grid.querySelector(`[data-kabo-review-id="${review.id}"]`)) return;

      const card = document.createElement('figure');
      card.className = 'cv-review';
      card.dataset.kaboReviewId = review.id;

      const stars = document.createElement('div');
      stars.className = 'cv-review__stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${review.rating} von 5 Sternen`);
      for (let star = 1; star <= 5; star += 1) {
        const symbol = document.createElement('span');
        symbol.setAttribute('aria-hidden', 'true');
        symbol.textContent = '★';
        if (star > review.rating) symbol.className = 'cv-review__star-empty';
        stars.appendChild(symbol);
      }

      const quote = document.createElement('blockquote');
      const text = document.createElement('p');
      text.textContent = review.text;
      quote.appendChild(text);

      const caption = document.createElement('figcaption');
      const avatar = document.createElement('span');
      avatar.className = 'cv-review__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = displayAuthor(review.author).charAt(0).toUpperCase();
      const author = document.createElement('span');
      author.textContent = displayAuthor(review.author);
      caption.append(avatar, author);
      if (review.date) {
      const date = document.createElement('time');
      date.dateTime = review.date;
      date.textContent = new Date(review.date + 'T12:00:00Z').toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' });
      caption.append(date);
      }

      card.append(stars, quote, caption);
      if (review.images?.length) {
        const photos = document.createElement('div');
        photos.className = 'cv-review__photos';
        review.images.forEach((src, index) => {
          const link = document.createElement('button');
          link.type = 'button';
          link.addEventListener('click', () => {
            if (!openGallery) openGallery = createReviewGallery(page);
            openGallery(review, index, link);
          });
          link.setAttribute('aria-label', `Bewertungsfoto ${index + 1} von ${displayAuthor(review.author)} vergrößern`);
          const image = document.createElement('img');
          image.src = src + '&width=240';
          image.alt = `DryStep – Foto ${index + 1} zur Bewertung von ${displayAuthor(review.author)}`;
          image.width = 90;
          image.height = 120;
          image.loading = 'lazy';
          link.append(image);
          photos.append(link);
        });
        card.append(photos);
      }
      grid.appendChild(card);
    });

    renderOriginNote(section, grid, visibleReviews, page.dataset.productName);
    normalizeReviewDisplay(section);
  };

  document.querySelectorAll('[data-kabo-page]').forEach(render);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kabo-page]').forEach(render);
  });
})();

/* Presentation only. The existing theme owns product submissions and analytics. */
(() => {
  const initialize = (page) => {
    if (page.dataset.cvReady) return;
    page.dataset.cvReady = 'true';
    const currentURL = new URL(window.location.href);
    const modelLinks = [...page.querySelectorAll('[data-cp-model]')];
    modelLinks.forEach((link) => {
      const url = new URL(link.href, location.href);
      const from = currentURL.searchParams.get('from');
      if (from && ['clean','drive','weekend','studio','living'].includes(from)) url.searchParams.set('from', from);
      link.href = url.href;
    });
    const requestedModel = currentURL.searchParams.get('model');
    const modelLink = modelLinks.find(link => link.dataset.cpModel === requestedModel);
    if (modelLink && new URL(modelLink.href).pathname !== location.pathname) {
      location.replace(modelLink.href);
      return;
    }
    const knownWorlds = ['clean','drive','weekend','studio','living'];
    const from = currentURL.searchParams.get('from');
    const breadcrumb = page.querySelector('.cv-breadcrumb a');
    const worldReturn = page.querySelector('.cv-world-return a');
    const breadcrumbWorld = breadcrumb?.getAttribute('href')?.match(/\/collections\/kabo-(clean|drive|weekend|studio|living)/)?.[1];
    const activeWorld = knownWorlds.includes(from) ? from : breadcrumbWorld;
    if (activeWorld) {
      const worldLabel = activeWorld[0].toUpperCase() + activeWorld.slice(1);
      const worldURL = `/collections/kabo-${activeWorld}`;
      if (breadcrumb) {
        breadcrumb.href = worldURL;
        breadcrumb.textContent = `← Zurück zu KABO ${worldLabel}`;
      }
      if (worldReturn) {
        worldReturn.href = worldURL;
        worldReturn.textContent = `Weitere Produkte aus KABO ${worldLabel} entdecken`;
      }
    }
    const slides = [...page.querySelectorAll('[data-cv-slide]')];
    const thumbs = [...page.querySelectorAll('[data-cv-thumb]')];
    const dialog = page.querySelector('[data-cv-dialog]');
    const enlarged = page.querySelector('[data-cv-enlarged]');
    const count = page.querySelector('[data-cv-gallery-count]');
    const zoomIcon = page.querySelector('.cv-gallery__zoom');
    if (zoomIcon) zoomIcon.textContent = '⛶';
    let active = 0;
    let suppressGalleryClickUntil = 0;
    const selectImage = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== active; });
      thumbs.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === active)); });
      const source = slides[active].querySelector('img');
      if (source && enlarged) {
        enlarged.src = source.currentSrc || source.src;
        enlarged.alt = source.alt || `${page.dataset.productName} – Produktbild ${active + 1}`;
      }
      if (count) count.textContent = `${active + 1} / ${slides.length}`;
    };
    const bindSwipe = (target) => {
      if (!target || slides.length < 2) return;
      let start = null;
      target.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) { start = null; return; }
        const touch = event.touches[0];
        start = { x: touch.clientX, y: touch.clientY };
      }, { passive: true });
      target.addEventListener('touchend', (event) => {
        if (!start || event.changedTouches.length !== 1) { start = null; return; }
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy) * 1.15) return;
        suppressGalleryClickUntil = Date.now() + 450;
        selectImage(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
      target.addEventListener('touchcancel', () => { start = null; }, { passive: true });
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectImage(index)));
    slides.forEach((slide, index) => slide.addEventListener('click', () => {
      if (Date.now() < suppressGalleryClickUntil) return;
      selectImage(index);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }));
    bindSwipe(page.querySelector('.cv-gallery__stage'));
    bindSwipe(dialog?.querySelector('.cv-dialog__stage'));
    page.querySelector('[data-cv-close]')?.addEventListener('click', () => dialog?.close());
    page.querySelector('[data-cv-prev]')?.addEventListener('click', () => selectImage(active - 1));
    page.querySelector('[data-cv-next]')?.addEventListener('click', () => selectImage(active + 1));
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        selectImage(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });

    const form = page.querySelector('.cv-form');
    const primarySubmit = page.querySelector('[data-cv-submit]');
    const sticky = page.querySelector('[data-cv-sticky]');
    const stickySubmit = page.querySelector('[data-cv-sticky-submit]');
    if (primarySubmit && stickySubmit) {
      const mirrorSubmit = () => { stickySubmit.disabled = primarySubmit.disabled; };
      mirrorSubmit();
      const buttonObserver = new MutationObserver(mirrorSubmit);
      buttonObserver.observe(primarySubmit, { attributes: true, attributeFilter: ['disabled'] });
    }
    if (sticky && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting && entry.intersectionRatio >= 0.5;
      }, { threshold: [0, 0.5] });
      observer.observe(primarySubmit || form);
    }

    let variants = [];
    try { variants = JSON.parse(page.querySelector('[data-cv-variants]')?.textContent || '[]'); }
    catch (_) { /* The Shopify form remains usable without enhancement. */ }
    const variantControl = page.querySelector('[data-cv-variant]');
    const quantityControl = page.querySelector('[data-qty-input]');
    const updateShipping = () => {
      const variant = variants.find((item) => String(item.id) === variantControl?.value);
      if (!variant) return;
      const quantity = Math.max(1, Number(quantityControl?.value) || 1);
      page.querySelectorAll('[data-cv-shipping]').forEach((note) => {
        note.textContent = variant.price * quantity >= 5500 ? note.dataset.free : note.dataset.paid;
      });
    };
    updateShipping();
    quantityControl?.addEventListener('input', updateShipping);
    quantityControl?.addEventListener('change', updateShipping);
    page.addEventListener('click', (event) => {
      if (event.target.closest('[data-qty-plus], [data-qty-minus]')) queueMicrotask(updateShipping);
    });
    const reviewForm = page.querySelector('.cv-review-form');
    if (reviewForm?.querySelector('[role="alert"], [role="status"]')) {
      reviewForm.closest('details').open = true;
    }
    const currency = page.dataset.currency || 'EUR';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency });
    let delivery = '';
    try { delivery = JSON.parse(page.querySelector('[data-cv-delivery]')?.textContent || '""'); } catch (_) { /* Preserve server-rendered delivery. */ }
    const updateVariant = () => {
      const variant = variants.find((item) => String(item.id) === variantControl.value);
      if (!variant) { if (primarySubmit) primarySubmit.disabled = true; return; }
      updateShipping();
      page.querySelectorAll('[data-cv-price]').forEach((price) => { price.textContent = money.format(variant.price / 100); });
      if (primarySubmit) primarySubmit.disabled = !variant.available;
      page.querySelectorAll('[data-cv-submit-label]').forEach((label) => { label.textContent = variant.available ? 'In den Warenkorb' : 'Aktuell ausverkauft'; });
      const availability = page.querySelector('[data-cv-availability]');
      if (availability) availability.textContent = variant.available ? `Bestellbar · Lieferung in ${delivery}` : 'Dieses Set ist aktuell nicht verfügbar.';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      const variantSource = variant.featured_image?.src?.split('?')[0];
      if (variantSource) {
        const index = slides.findIndex((slide) => slide.querySelector('img')?.src.split('?')[0] === variantSource);
        if (index !== -1) selectImage(index);
      }
    };
    const selected = variants.find(item => String(item.id) === variantControl?.value);
    if (selected) updateVariant();
    else if (primarySubmit) {
      primarySubmit.disabled = true;
      page.querySelectorAll('[data-cv-submit-label]').forEach(label => { label.textContent = 'Bitte Farbe wählen'; });
    }
    variantControl?.addEventListener('change', updateVariant);
    selectImage(active);
    const ratings = [...page.querySelectorAll('.cv-review__stars')].map(el => el.querySelectorAll('span:not(.cv-review__star-empty)').length).filter(n => n > 0);
    if (ratings.length) {
      const average = ratings.reduce((sum, n) => sum+n, 0)/ratings.length;
      const jump = page.querySelector('.cv-review-jump');
      if (jump) jump.textContent = `${average.toLocaleString('de-DE',{maximumFractionDigits:1})} von 5 · ${ratings.length} ${ratings.length === 1 ? 'Bewertung' : 'Bewertungen'}`;
      const summary = document.createElement('a');
      summary.href = '#cv-reviews'; summary.className = 'cv-review-summary';
      const stars = document.createElement('span'); stars.className = 'cv-review-summary__stars'; stars.setAttribute('aria-hidden','true'); stars.textContent = '★'.repeat(Math.round(average))+'☆'.repeat(5-Math.round(average));
      const score = document.createElement('span'); score.className = 'cv-review-summary__score'; score.textContent = average.toLocaleString('de-DE',{minimumFractionDigits:1,maximumFractionDigits:1});
      const reviewCount = document.createElement('span'); reviewCount.className = 'cv-review-summary__count'; reviewCount.textContent = `· ${ratings.length} ${ratings.length === 1 ? 'Bewertung' : 'Bewertungen'}`;
      summary.append(stars,score,reviewCount);
      summary.setAttribute('aria-label', `${average.toLocaleString('de-DE')} von 5 Sternen aus ${ratings.length} Bewertungen`);
      page.querySelector('h1')?.before(summary);
    }
    page.querySelectorAll('a[href^="#cv-"]').forEach((link) => link.addEventListener('click', (event) => {
      const target = page.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }));
  };
  document.querySelectorAll('[data-kabo-page]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kabo-page]').forEach(initialize);
  });

})();


